import { render, staticRenderFns } from "./DataComplianceDetailManager.vue?vue&type=template&id=80b99a8a&scoped=true"
import script from "./DataComplianceDetailManager.vue?vue&type=script&lang=js"
export * from "./DataComplianceDetailManager.vue?vue&type=script&lang=js"
import style0 from "./DataComplianceDetailManager.vue?vue&type=style&index=0&id=80b99a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b99a8a",
  null
  
)

export default component.exports